import axios from './axios';
import { DATA_PER_PAGE } from '../constants/Values';

let page = 1;

export const addTemplate = template =>
  axios.post('/core/notifications/templates', {
    body: template.body,
    header: template.header,
    type: template.type,
  });

export const deleteTemplate = id => axios.delete(`/core/notifications/templates/${id}`);

export const editTemplate = (id, template) =>
  axios.put(`/core/notifications/templates/${id}`, {
    body: template.body,
    header: template.header,
    type: template.type,
  });

export const getTemplateById = id => axios.get(`/core/notifications/templates/${id}`);

export const getTemplates = loadingMore => {
  page = loadingMore ? page + 1 : 1;
  return axios.post('/core/notifications/templates/search', {
    pagination: {
      pageNumber: page,
      size: DATA_PER_PAGE,
      sort: [
        {
          direction: 'ASC',
          property: 'header',
        },
      ],
    },
  });
};
